import { memo } from 'react';
import type { Node } from 'react';

import classNames from 'classnames';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import svg from './star-rating.svg';
import styles from './StarRating.style';

type Props = {
  className?: string;
  title?: string;
  isActive?: boolean;
};
const useStyles = createUseThemeStyles(styles);

const StarRating = ({ className, title, isActive }: Props): Node => {
  const classes = useStyles({
    isActive,
  });
  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default memo<Props>(StarRating);
